export let initialvalue = {
  // show: true,
  component: "MainDashboard",
  logoutprop: false,
  allowaccess: true,
  loading: false,
  forgotpass: false,
  AdminDashboard: "",
};

export const initialContent = {
  homepage_first_text: "",
  homepage_second_text: "",
  banner_image: "",
  back_image: "",
  homepage_youtube: "",
  keyborad_section_text: "",
  keyboard_image: "",
  faq_questions_answers: [],
  backgroundImage: "",
  dashboardContent: {
    welcome: "",
    welcome_text: "",
    explain_video: "",
    emul_form:
      "https://forms.monday.com/forms/embed/ed24ff35b9056bc8ee13f920d6c5ee74?r=use1",
  },
  supportsection: {
    head_text: "",
    below_text: "",
    iframe_link: "",
    faq: [],
  },
  resorcesSection: {
    youtube: "",
    key_text: "",
    key_image: "",
  },
  renderSection: {
    form: "",
    publicDownloadUrl: "",
  },
  downloadSection: {
    youtubeLink: "",
    notes: "",
  },
  adminaccess: true,
  hompage_message: "",
  dashboard_message: "",
  render_message: "",
  support_message: "",
  res_message: "",
  download_message: "",
  unload_loader: true,
  mailingList: "",
};
